import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * La barra de abajo de la maqueta cuando hay filas elegidas («2 seleccionados ·
 * suben en promedio 20 %» y los botones del lote). Queda pegada al pie de la
 * pantalla mientras se recorre la lista. Sin filas elegidas no se dibuja.
 *
 * Es opaca, con el tinte azul de la maqueta encima: translúcida dejaba ver las
 * filas de abajo y se leía mal. Flota sobre el relleno de abajo del `main`
 * (los botones de ayuda), no encima de ellos: `sticky` mide desde ahí.
 */
export function BarraDeLote({
  visible,
  resumen,
  acciones,
  className,
}: {
  visible: boolean;
  resumen: ReactNode;
  acciones: ReactNode;
  className?: string;
}) {
  if (!visible) return null;
  return (
    <div
      role="region"
      aria-label="Acciones sobre las elegidas"
      className={cn(
        'sticky bottom-4 z-20 mx-auto flex w-full max-w-4xl flex-wrap items-center justify-between gap-3',
        'rounded-tarjeta border border-primary/20 bg-card px-5 py-3 shadow-card',
        '[background-image:linear-gradient(hsl(var(--primary)/0.06),hsl(var(--primary)/0.06))]',
        'dark:[background-image:linear-gradient(hsl(var(--primary)/0.1),hsl(var(--primary)/0.1))]',
        className
      )}
    >
      <div className="min-w-0 text-sm text-foreground">{resumen}</div>
      <div className="flex flex-wrap items-center gap-2">{acciones}</div>
    </div>
  );
}
